import React from 'react';
import styles from '@/styles/components/InfoTooltip.module.css';
import ReactTooltip from 'react-tooltip';

export interface InfoTooltipData {
  id: string | number;
}

export const InfoTooltip: React.FC<InfoTooltipData> = ({ id, children }) => {
  const tooltipId = `info-tooltip-${id}`;
  return (
    <div className={styles.tooltipWrapper}>
      <button className={styles.tooltipButton} data-tip data-for={tooltipId} />
      <ReactTooltip
        className={styles.tooltip}
        id={tooltipId}
        type="light"
        effect="solid"
        place="top"
      >
        {children}
      </ReactTooltip>
    </div>
  );
};
